import {SoftDeleteEntity} from './soft-delete-entity';
import {BaseEntity} from './base-entity';
import {Card} from './card';
import {AppIdentityUserLight} from './app-identity-user-light';

export class CashbackGroup extends SoftDeleteEntity {
  name: string;
  code: string;

  maxCashbackPerMonth: number;
  maxCashbackPerTransaction: number;
  cashbackFactor: number;

  isEnabled: boolean;
  isEnabledCalc: boolean;

  activeFrom: Date;
  activeUntil: Date|null;
  membersCount: number;

  filterMerchantIds: string; // comma separated
  filterMccCodes: string; // comma separated, asterisks as wildcard, x-y for range

}

export class CashbackGroupMembership extends BaseEntity {
  cardId: number;
  card: Card;

  cashbackGroupId: number;
  cashbackGroup: CashbackGroup;

  joinDate: Date;
  leaveDate: Date|null;

  addedById: string;
  addedBy: AppIdentityUserLight;

  isActive: boolean;
  isActiveCalc: boolean;


}
